import React from 'react'
import { reportResponse } from '../../layouts/Aws.js'
import PropTypes from 'prop-types'

// mui core
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js'
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'
import Card from '../../components/Card/Card.js'
import CardBody from '../../components/Card/CardBody.js'
import { successColor, dangerColor, grayColor } from '../../assets/jss/material-dashboard-pro-react.js'

const useStyles = makeStyles(styles)

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2
})

export default function SummaryFigures ({ reportPeriod }) {
  const classes = useStyles()

  const [gross, setGross] = React.useState(0)
  const [net, setNet] = React.useState(0)
  const [diff, setDiff] = React.useState(null)
  const [profit, setProfit] = React.useState(0)
  const [gm, setGM] = React.useState('-')

  React.useEffect(() => {
    updateData(reportPeriod.startDate, reportPeriod.endDate, reportPeriod.comparisonDate, reportPeriod.sites, reportPeriod.token)
  }, [])

  React.useEffect(() => {
    if (reportPeriod.startDate && reportPeriod.endDate && reportPeriod.sites) {
      updateData(reportPeriod.startDate, reportPeriod.endDate, reportPeriod.comparisonDate, reportPeriod.sites, reportPeriod.token)
    }
  }, [reportPeriod])

  const updateData = (startDate, endDate, comparisonDate, sites, token) => {
    // get last 7 days by default
    reportResponse(startDate, endDate, comparisonDate, sites, 'daily', 'series', token).then(seriesRes => {
      if (seriesRes.error || seriesRes.errorType) {
        console.log(seriesRes)
      } else {
        reportResponse(startDate, endDate, comparisonDate, sites, 'daily', 'summary', token).then(summaryRes => {
          if (summaryRes.error || summaryRes.errorType) {
            console.log(summaryRes)
          } else {
            if (comparisonDate) {
              let compProfit = 0
              seriesRes.grossProfit[1].forEach(sale => {
                compProfit += parseFloat(sale)
              })

              let diff = 100.0

              // profit
              if (compProfit !== 0) {
                diff = ((summaryRes.grossProfit - compProfit) / (compProfit * 1.0)) * 100.0
              }

              setDiff(diff)
            }

            setGross(summaryRes.grossSales)
            setNet(summaryRes.netSales)
            setProfit(summaryRes.grossProfit)
            setGM(summaryRes.grossMargin)
          }
        })
      }
    })
  }

  const getDiff = (p) => {
    let comparison
    const colour = diff >= 0 ? successColor[0] : dangerColor[0]
    const arrow = diff >= 0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
    if (diff !== null && reportPeriod.comparisonDate) {
      comparison = <p style={{ margin: '0', lineHeight: '1.8em', color: colour }}><i className={arrow} style={{ color: colour }}/>&nbsp;{diff.toFixed(2)}%</p>
    } else {
      comparison = <p style={{ margin: '0', lineHeight: '1.8em', color: grayColor[0] }}>-</p>
    }

    return comparison
  }

  const rowHeight = '90px'

  return <GridContainer alignItems="stretch">
    <GridItem xs={12} sm={12} md={12} lg={12} xl={2} style={{ height: rowHeight, marginBottom: '5px' }}>
      <Card color="danger" style={{ marginTop: 0, height: '100%' }}>
        <CardBody>
          <GridContainer alignItems="stretch">
            <GridItem xs={12}>
              <h4 className={classes.cardTitle} style={{ color: 'white', marginTop: 0 }}><strong>Reporting Period</strong></h4>
            </GridItem>
            <GridItem xs={12}>
              <p style={{ marginBottom: 0 }}>{reportPeriod.startDate} to {reportPeriod.endDate}</p>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
    <GridItem xs={12} sm={12} md={12} lg={12} xl={10}>
      <GridContainer alignItems="stretch">
        <GridItem xs={12} sm={12} md={6} lg xl style={{ height: rowHeight, marginBottom: '5px' }}>
          <Card style={{ marginTop: 0, height: '100%' }}>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <div style={{ height: '100%' }}>GROSS</div>
                </GridItem>
                <GridItem xs={12}>
                  <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{formatter.format(gross)}</h3></div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg xl style={{ height: rowHeight, marginBottom: '5px' }}>
          <Card style={{ marginTop: 0, height: '100%' }}>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <div style={{ height: '100%' }}>NET</div>
                </GridItem>
                <GridItem xs={12}>
                  <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{formatter.format(net)}</h3></div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg xl style={{ height: rowHeight, marginBottom: '5px' }}>
          <Card style={{ marginTop: 0, height: '100%' }}>
            <CardBody>
              <GridContainer>
                <GridItem xs={6}>
                  <div style={{ height: '100%' }}>PROFIT</div>
                </GridItem>
                <GridItem xs={6}>
                  <div style={{ height: '100%', textAlign: 'right' }}>{getDiff()}</div>
                </GridItem>
                <GridItem xs={12}>
                  <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{formatter.format(profit)}</h3></div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg xl style={{ height: rowHeight, marginBottom: '5px' }}>
          <Card style={{ marginTop: 0, height: '100%' }}>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <div style={{ height: '100%' }}>MARGIN</div>
                </GridItem>
                <GridItem xs={12}>
                  <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{gm}</h3></div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </GridItem>
  </GridContainer>
}

SummaryFigures.propTypes = {
  reportPeriod: PropTypes.object
}
